
/* Rhino Seal Supply — Cart Drawer Per-Line Toggle v2 */
(function() {
  'use strict';

  const SELLING_PLAN_ID = window.rhinoSellingPlanId || 2649030715;
  const DISCOUNT_PERCENT = 10;
  let isUpdating = false;

  // Inject toggle CSS
  const style = document.createElement('style');
  style.textContent = `
    .rhino-pack-label {
      font-size: 11px;
      color: #d4a853;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      margin-top: 2px;
    }
    .rhino-line-toggle {
      display: flex;
      align-items: center;
      gap: 0;
      margin-top: 8px;
      background: #1a1a1a;
      border-radius: 6px;
      padding: 3px;
      position: relative;
      width: fit-content;
      border: 1px solid #333;
    }
    .rhino-toggle-btn {
      position: relative;
      z-index: 2;
      padding: 5px 12px;
      border: none;
      background: transparent;
      color: #999;
      font-size: 11px;
      font-weight: 600;
      cursor: pointer;
      border-radius: 4px;
      transition: color 0.2s ease;
      text-transform: uppercase;
      letter-spacing: 0.03em;
      white-space: nowrap;
    }
    .rhino-toggle-btn.active {
      color: #000;
      background: #d4a853;
      box-shadow: 0 1px 3px rgba(0,0,0,0.3);
      transition: all 0.25s cubic-bezier(0.23, 1, 0.32, 1);
    }
    .rhino-toggle-btn:hover:not(.active) {
      color: #d4a853;
    }
    .rhino-line-savings {
      font-size: 10px;
      color: #4ade80;
      font-weight: 600;
      margin-top: 3px;
      display: flex;
      align-items: center;
      gap: 4px;
    }
    .rhino-line-savings svg {
      width: 10px;
      height: 10px;
    }
    .rhino-commitment-notice {
      font-size: 11px;
      color: #888;
      margin: 10px 0;
      padding: 10px 14px;
      background: #1a1a1a;
      border: 1px solid #333;
      border-radius: 6px;
      line-height: 1.5;
    }
    .rhino-commitment-notice strong {
      color: #d4a853;
      display: block;
      margin-bottom: 3px;
    }
    .rhino-updating {
      opacity: 0.5;
      pointer-events: none;
      transition: opacity 0.2s ease;
    }
  `;
  document.head.appendChild(style);

  function initCartToggles() {
    const cartItems = document.querySelectorAll('.cart-items__table-row:not(.cart-items__nested-line)');
    
    cartItems.forEach(function(row) {
      if (row.querySelector('.rhino-line-toggle')) return;
      
      const detailsCell = row.querySelector('.cart-items__details');
      if (!detailsCell) return;
      
      const key = row.getAttribute('data-key');
      if (!key) return;
      
      // Check if this item currently has a selling plan
      const sellingPlanEl = detailsCell.querySelector('.cart-items__variants-wrapper p');
      const hasSellingPlan = sellingPlanEl && (
        sellingPlanEl.textContent.toLowerCase().includes('monthly') ||
        sellingPlanEl.textContent.toLowerCase().includes('delivery')
      );
      
      // Add 12-Pack Case label
      const titleRow = detailsCell.querySelector('.cart-items__title-row');
      if (titleRow && !detailsCell.querySelector('.rhino-pack-label')) {
        const packLabel = document.createElement('div');
        packLabel.className = 'rhino-pack-label';
        packLabel.textContent = '12-Pack Case';
        titleRow.after(packLabel);
      }
      
      // Create toggle container
      const toggleContainer = document.createElement('div');
      toggleContainer.style.cssText = 'margin-top: 6px;';
      
      const toggle = document.createElement('div');
      toggle.className = 'rhino-line-toggle';
      toggle.innerHTML = `
        <button type="button" class="rhino-toggle-btn ${hasSellingPlan ? 'active' : ''}" data-mode="monthly">Monthly</button>
        <button type="button" class="rhino-toggle-btn ${!hasSellingPlan ? 'active' : ''}" data-mode="onetime">One-Time</button>
      `;
      toggleContainer.appendChild(toggle);
      
      // Add savings indicator for monthly
      if (hasSellingPlan) {
        const savings = document.createElement('div');
        savings.className = 'rhino-line-savings';
        savings.innerHTML = `<svg viewBox="0 0 16 16" fill="currentColor"><path d="M8 16A8 8 0 108 0a8 8 0 000 16zm3.78-9.72a.75.75 0 00-1.06-1.06L7 8.94 5.28 7.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.06 0l4.25-4.25z"/></svg> Save ${DISCOUNT_PERCENT}% with monthly schedule`;
        toggleContainer.appendChild(savings);
      }
      
      // Insert after pack label or title row
      const packLabel = detailsCell.querySelector('.rhino-pack-label');
      if (packLabel) {
        packLabel.after(toggleContainer);
      } else if (titleRow) {
        titleRow.after(toggleContainer);
      }
      
      // Handle toggle clicks
      toggle.querySelectorAll('.rhino-toggle-btn').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (isUpdating) return;
          
          const mode = this.getAttribute('data-mode');
          const currentActive = toggle.querySelector('.rhino-toggle-btn.active');
          if (currentActive && currentActive.getAttribute('data-mode') === mode) return;
          
          // Visual update immediately
          toggle.querySelectorAll('.rhino-toggle-btn').forEach(b => b.classList.remove('active'));
          this.classList.add('active');
          
          // Show loading state
          row.classList.add('rhino-updating');
          isUpdating = true;
          
          updateLineSellingPlan(key, mode, row);
        });
      });
    });
  }
  
  function updateLineSellingPlan(lineKey, mode, row) {
    // Shopify cart change API with selling_plan
    const body = {
      id: lineKey,
      selling_plan: mode === 'monthly' ? SELLING_PLAN_ID : null
    };
    
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(r => r.json())
    .then(data => {
      isUpdating = false;
      // Refresh cart drawer section
      refreshCartDrawer();
    })
    .catch(err => {
      console.error('Cart update failed:', err);
      isUpdating = false;
      row.classList.remove('rhino-updating');
    });
  }
  
  function refreshCartDrawer() {
    fetch(window.location.pathname + '?sections=cart-drawer-section')
      .then(r => r.json())
      .then(data => {
        const html = data['cart-drawer-section'];
        if (html) {
          const container = document.getElementById('shopify-section-cart-drawer-section');
          if (container) {
            container.innerHTML = html;
            setTimeout(function() {
              initCartToggles();
              addCommitmentNotice();
            }, 150);
          }
        }
      })
      .catch(err => {
        console.error('Cart refresh failed:', err);
        // Fallback: just re-init toggles
        setTimeout(function() {
          document.querySelectorAll('.rhino-updating').forEach(el => el.classList.remove('rhino-updating'));
          initCartToggles();
        }, 200);
      });
  }
  
  function addCommitmentNotice() {
    const summary = document.querySelector('.cart-drawer__summary');
    if (!summary || summary.querySelector('.rhino-commitment-notice')) return;
    
    // Check if any items have monthly selected
    const hasMonthly = document.querySelector('.rhino-toggle-btn[data-mode="monthly"].active');
    if (!hasMonthly) return;
    
    const notice = document.createElement('div');
    notice.className = 'rhino-commitment-notice';
    notice.innerHTML = `
      <strong>Monthly Schedule Terms</strong>
      3-order minimum commitment. Billed monthly, ships as placed. No changes during first 3 deliveries. Modifications available after 3rd order.
    `;
    summary.prepend(notice);
  }
  
  // Initialize
  function init() {
    initCartToggles();
    addCommitmentNotice();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Observe cart drawer for dynamic content changes
  const observer = new MutationObserver(function(mutations) {
    let shouldInit = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        for (let node of mutation.addedNodes) {
          if (node.nodeType === 1 && (
            node.classList?.contains('cart-items__table-row') ||
            node.querySelector?.('.cart-items__table-row')
          )) {
            shouldInit = true;
          }
        }
      }
    });
    if (shouldInit) {
      setTimeout(init, 200);
    }
  });
  
  // Start observing once cart drawer exists
  function startObserving() {
    const cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer) {
      observer.observe(cartDrawer, { childList: true, subtree: true });
    } else {
      setTimeout(startObserving, 500);
    }
  }
  startObserving();
  
  // Listen for cart drawer open events
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[href*="cart"], .cart-icon-bubble, [data-cart-trigger]');
    if (trigger) {
      setTimeout(init, 400);
    }
  });
})();
